
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Button, Card } from 'react-bootstrap';
import Layout from '../../layout/Layout';
import { API } from '../../App';
import Cookies from 'js-cookie';
import Fancybox from '../../Component/FancyBox';

const KeyboardCategoriesView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState({
        name: '',
        // image: '',
        status: '',
        created_at: '',
        updated_at: ''
    });

    const loadData = async () => {
        try {
            const token = Cookies.get('jwt');
            const res = await API.post(`/keyboardCategories/${id}`,{}, {
                headers: { "authorization": `Bearer ${token}` }
            });
            if (res.data.response_code === 200) {
                setCategory(res.data.data);
            } else {
                navigate('/keyboard/category');
            }
        } catch (error) {
            console.error('Error fetching category:', error);
            navigate('/keyboard/category');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [id, navigate]);

    if (loading) {
        return <div className="loader"></div>;
    }

     return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3>
                    <Link to="/keyboard/category" className="btn btn-primary btn-icon me-3">
                        <i className="bx bxs-left-arrow-alt"></i>
                    </Link>
                    View Keyboard Category - <span>{category.name}</span>
                </h3>
                <Row className="align-items-center">
                    <Col md="auto" xs={6}>
                        <Link to={`/keyboard/category/edit/${id}`}>
                            <Button variant="primary">Edit</Button>
                        </Link>
                    </Col>
                </Row>
            </div>
            <div className="page-content">
                <Card>
                    <Card.Body>
                        <Fancybox>
                            <Row>
                                <Col md={3}>
                                    <div className="mb-4">
                                        <p className="mb-0 fw-bold">Name</p>
                                        <span>{category.name}</span>
                                    </div>
                                </Col>
                                {/* <Col md={3}>
                                    <div className="mb-4">
                                        <p className="mb-0 fw-bold">Image</p>
                                        <span>
                                            {category.image && (
                                                <Fancybox>
                                                    <a data-fancybox="gallery" href={category.image}>
                                                        <img src={category.image} className="hv-40 rounded-3" alt="Image" />
                                                    </a>
                                                </Fancybox>
                                            )}
                                        </span>
                                    </div>
                                </Col> */}
                                <Col md={3}>
                                    <div className="mb-4">
                                        <p className="mb-0 fw-bold">Status</p>
                                        <span>{category.status ? 'True' : 'False'}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className="mb-4">
                                        <p className="mb-0 fw-bold">Created At</p>
                                        <span>{new Date(category.created_at).toLocaleString('en-GB')}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className="mb-4">
                                        <p className="mb-0 fw-bold">Updated At</p>
                                        <span>{new Date(category.updated_at).toLocaleString('en-GB')}</span>
                                    </div>
                                </Col>
                            </Row>
                        </Fancybox>
                    </Card.Body>
                </Card>
            </div>
        </Layout>
    );
};

export default KeyboardCategoriesView;